// extracted by mini-css-extract-plugin
export default {"form":"EditIdeaModal_form__D4COy","formGroup":"EditIdeaModal_formGroup__CMcgp","buttons":"EditIdeaModal_buttons__JXzFe"};